import { ComponentEvents } from '../../../../global/interfaces/component.interface';

const EVENT_PREFIX = 'FormstepSelectIconEvents__';

/** The type of custom events emitted */
export type FormstepSelectIconEventTypes = {
	REQUEST_VALIDATION: string;
};

/** The event names for the above events */
export const FormstepSelectIconEvents: ComponentEvents<FormstepSelectIconEventTypes> = {
	REQUEST_VALIDATION: EVENT_PREFIX + 'REQUEST_VALIDATION',
};
